import lookingForWealth from 'assets/images/lookingForWealth.jpeg';
import lookingForWealthOverview from 'assets/images/booksOverview/lookingForWealth.png';

import { FLIP_BOOKS } from '../const';

import { getFlipBookPurchases } from './utils';

const lookForHealthFlipBook = {
  book: {
    id: 'suche-nach-reichtum',
    format: FLIP_BOOKS,
    title: 'In search of wealth',
    subtitle: 'Revelations from the world of risks and returns',
    videos: 'Erwin W. Heri, Andreas Homberger and Andreas Löpfe',
    layoutAndProduction: 'Hanspeter Frey',
    scope: { pages: 52, videos: 49 },
    price: [29, 35],
    introductions: [
      {
        type: 'textWithList',
        text: 'Investing money is not difficult',
        list: ['Lack of basic knowledge of money and finance', 'Fairy tale and fantasy world surrounding money investment'],
      },
      'In Revelations the author shows bluntly',
      'The book is an entertaining read for every investor with an inquisitive mind',
      {
        type: 'textWithList',
        text: 'The hope of making a fast buck on the stock exchange is omnipresent',
        list: ['Prof. Dr. Heinz Zimmermann, University of Basel, author of Finance Compact Plus'],
      },
      {
        type: 'textWithList',
        text: 'Money, pensions and investments',
        list: ['Mark Dittli, Editor-in-Chief of The Market'],
      },
      {
        type: 'textWithList',
        text: 'For decades probably the most distinguished educator in Switzerland',
        list: ['Dr. Pirmin Hotz, owner of the asset management firm of the same name in Baar'],
      },
    ],
    image: lookingForWealth,
    overviewImg: lookingForWealthOverview,
  },
  bookIds: [31, 32],
  purchases: getFlipBookPurchases([29, 35], [32, 31]),
};

export default lookForHealthFlipBook;
